import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
import { Contract, ContractFactory, utils } from "ethers";
var _abi = [{
  inputs: [],
  name: "getCurrentBlockTimestamp",
  outputs: [{
    internalType: "uint256",
    name: "timestamp",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "addr",
    type: "address"
  }],
  name: "getEthBalance",
  outputs: [{
    internalType: "uint256",
    name: "balance",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "target",
      type: "address"
    }, {
      internalType: "uint256",
      name: "gasLimit",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "callData",
      type: "bytes"
    }],
    internalType: "struct UniswapInterfaceMulticall.Call[]",
    name: "calls",
    type: "tuple[]"
  }],
  name: "multicall",
  outputs: [{
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }, {
    components: [{
      internalType: "bool",
      name: "success",
      type: "bool"
    }, {
      internalType: "uint256",
      name: "gasUsed",
      type: "uint256"
    }, {
      internalType: "bytes",
      name: "returnData",
      type: "bytes"
    }],
    internalType: "struct UniswapInterfaceMulticall.Result[]",
    name: "returnData",
    type: "tuple[]"
  }],
  stateMutability: "nonpayable",
  type: "function"
}];
var _bytecode = "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";
export var UniswapInterfaceMulticall__factory = /*#__PURE__*/function (_ContractFactory) {
  _inherits(UniswapInterfaceMulticall__factory, _ContractFactory);

  var _super = _createSuper(UniswapInterfaceMulticall__factory);

  function UniswapInterfaceMulticall__factory(signer) {
    _classCallCheck(this, UniswapInterfaceMulticall__factory);

    return _super.call(this, _abi, _bytecode, signer);
  }

  _createClass(UniswapInterfaceMulticall__factory, [{
    key: "deploy",
    value: function deploy(overrides) {
      return _get(_getPrototypeOf(UniswapInterfaceMulticall__factory.prototype), "deploy", this).call(this, overrides || {});
    }
  }, {
    key: "getDeployTransaction",
    value: function getDeployTransaction(overrides) {
      return _get(_getPrototypeOf(UniswapInterfaceMulticall__factory.prototype), "getDeployTransaction", this).call(this, overrides || {});
    }
  }, {
    key: "attach",
    value: function attach(address) {
      return _get(_getPrototypeOf(UniswapInterfaceMulticall__factory.prototype), "attach", this).call(this, address);
    }
  }, {
    key: "connect",
    value: function connect(signer) {
      return _get(_getPrototypeOf(UniswapInterfaceMulticall__factory.prototype), "connect", this).call(this, signer);
    }
  }], [{
    key: "createInterface",
    value: function createInterface() {
      return new utils.Interface(_abi);
    }
  }, {
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new Contract(address, _abi, signerOrProvider);
    }
  }]);

  return UniswapInterfaceMulticall__factory;
}(ContractFactory);
UniswapInterfaceMulticall__factory.bytecode = _bytecode;
UniswapInterfaceMulticall__factory.abi = _abi;